// src/packages/dhipaya/motor/dhipaya_truck_2p3p_2025/DhipayaTruckCard.jsx
import React from "react";
import "./dhipaya_truck.css";

export default function DhipayaTruckCard({ onSelect }) {
  return (
    <div className="pkg-card dhipaya-truck">
      <div className="pkg-body">
        <h3>Dhipaya Truck 2+ / 3+</h3>
        <p>โค้ด 320/420/520 • แยกมี/ไม่มีอุปกรณ์ • 4–12 ตัน / &gt;12 ตัน</p>
        <ul className="pkg-list">
          <li>ทุน 100,000–500,000 บาท</li>
          <li>ซ่อมอู่ (2+) / ชนกับยานพาหนะทางบกเท่านั้น</li>
          <li>ครอบคลุมความรับผิดต่อบุคคลภายนอกตามเงื่อนไข</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
